function getRandomNumber(min = 10000, max = 99999) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export default getRandomNumber;
